import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './StudentLogin.css';
import BrowserRecommendation from '../components/BrowserRecommendation';
function StudentLogin() {
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErreur('');
    setIsLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password: motDePasse,
    });

    setIsLoading(false);

    if (error) {
      setErreur("Email ou mot de passe incorrect");
    } else {
      // Vérifier que c'est bien un étudiant
      const userRole = data?.user?.user_metadata?.role;
      
      if (userRole === 'prof') {
        setErreur("Vous êtes professeur. Veuillez utiliser la page de connexion professeur.");
        await supabase.auth.signOut();
      } else {
        navigate('/dashboard');
      }
    }
  };

  return (
    <div className="student-login-container">
     <BrowserRecommendation variant="banner" /> 
      {/* Lettres arabes décoratives en arrière-plan */}
      <div className="student-arabic-background">
        <div className="student-arabic-letter letter-1">ع</div>
        <div className="student-arabic-letter letter-2">ل</div>
        <div className="student-arabic-letter letter-3">م</div>
      </div>

      {/* Bouton retour */}
      <button onClick={() => navigate('/')} className="back-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Retour
      </button>

      {/* Carte de connexion */}
      <div className="student-login-card">
        <div className="student-login-header">
          <div className="student-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 14l9-5-9-5-9 5 9 5z"></path>
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"></path>
            </svg>
          </div>
          <h2 className="student-title">Espace Étudiant</h2>
          <p className="student-subtitle">طالب</p>
          <p className="student-description">Connectez-vous pour accéder à vos cours</p>
        </div>

        <form onSubmit={handleLogin} className="student-login-form">
          <div className="student-form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="student-input-field"
            />
          </div>

          <div className="student-form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              value={motDePasse}
              onChange={(e) => setMotDePasse(e.target.value)}
              required
              className="student-input-field"
            />
          </div>

          {erreur && <div className="student-error-message">{erreur}</div>}

          <button type="submit" className="student-login-button" disabled={isLoading}>
            {isLoading ? (
              <span className="student-spinner"></span>
            ) : (
              "Se connecter"
            )}
          </button>
        </form>

        <div className="student-login-footer">
          <Link to="/forgot-password" className="student-forgot-password">
            Mot de passe oublié ?
          </Link>
          <p className="student-register-link">
            Pas encore de compte ? <Link to="/register?role=student">S'inscrire</Link>
          </p>
          <div className="student-divider">
            <span>ou</span>
          </div>
          <Link to="/professor-login" className="student-switch-link">
            Vous êtes professeur ? Connectez-vous ici
          </Link>
        </div>
      </div>
    </div>
  );
}

export default StudentLogin;
